import { Component, OnInit, Input } from '@angular/core';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { EntityContactParam } from '../../viewmodel'; 
import { EntityParam } from '../../viewmodel';
import { SharedService } from '../../services/shared.service';
import { EntityService } from '../../services/entity.service';
import { FoucsChangeService } from '../../services/focuschange.service';

@Component({
  selector: 'entity-detail',
  templateUrl: './entitydetail.component.html'
})
export class EntitydetailComponent implements OnInit {
    @Input() entity: any;
    //@Input() landingpage: string;
    projectId: number = 0;
    showDeleteDevTeamContactPopup: boolean = false;
    currentDeleteDevTeamContactId: number = 0;
    summaryUrl = '/MIH/#/entity/application'; 
    @Input('isAppEditable') isAppEditable: boolean = false;

    constructor(private router: Router
        , private activeRoute: ActivatedRoute
        , private sharedService: SharedService
        , private entityService: EntityService
        , private foucsChangeService: FoucsChangeService) { }

    ngOnInit() {
        let id = this.sharedService.getData('id');
        if (id != null) {
            let ids = JSON.parse(id);
            if (ids.projectId != null) {
                this.projectId = ids.projectId;
            }
        }      
    }

    addContacts() {
        this.router.navigate(['/addcontacts']);
    }

  cancelDeleteDevTeamContact() {
      this.showDeleteDevTeamContactPopup = false;
      this.currentDeleteDevTeamContactId = 0; 
      this.foucsChangeService.changeFocus(true);
  }

  deleteDevTeamContactpopup(MIHProjectDevTeamContactID) {
      this.showDeleteDevTeamContactPopup = true;
      this.currentDeleteDevTeamContactId = MIHProjectDevTeamContactID;
      this.foucsChangeService.changeFocus(false);
  }

  deleteDevTeamContact(devTeamContactId) {

          if (devTeamContactId > 0) {
              this.entityService.deleteDevTeamContact(devTeamContactId)
                  .subscribe(
                  success => {
                      if (!success.Success) {
                          //this.pageError.push(success.StatusMessage);
                          //this.currentDeleteDevTeamContactId = 0;
                      }
                      else {

                          this.showDeleteDevTeamContactPopup = false;
                          this.foucsChangeService.changeFocus(true);
                          this.currentDeleteDevTeamContactId = 0;
                          window.location.reload();
                      }
                  },
                  error => {
                      if (error.status == 401)
                          this.router.navigateByUrl('/login?session=0');

                      this.currentDeleteDevTeamContactId = 0;
                      //this.pageSuccess = []; this.pageError = [];
                      //this.pageError.push(error.ExceptionMessage);
                      window.scrollTo(0, 0);
                  })
          }

      }

  


  addContact(entity) {
      if (entity == null)
          return false;

      this.setEntityParam(entity)
      this.router.navigate(['/entity/addcontacts']);
  }

  setEntityParam(entity) {
      var eParam = new EntityParam();
      eParam.projectId = this.projectId;
      eParam.entityId = entity.MIHProjectDevTeamID;
      eParam.partyId = entity.PartyID;
      eParam.partyStagingId = entity.PartyStagingID;
   
      eParam.companyName = this.entity.organization;
      if (entity.PartyRoleLookup != null) {
          eParam.roleId = entity.PartyRoleLookup.SeqNo;
          eParam.partyRoleName = entity.PartyRoleLookup.LongName;
      }
      eParam.newEntityEntry = 'N';
      this.sharedService.setJsonData('entityParam', eParam);
  }
    
  editContact(contact, entity) {

      var entitycontactParams = new EntityContactParam();
      entitycontactParams.projectId = this.projectId;  
      entitycontactParams.entityId = entity.MIHProjectDevTeamID; 
      entitycontactParams.partyId = entity.PartyID;
      entitycontactParams.partyStagingId = entity.PartyStagingID;
      entitycontactParams.projectDevTeamContactId = contact.MIHProjectDevTeamContactID; 
      entitycontactParams.commContactId = contact.CommContactID;
      entitycontactParams.companyName = entity.PartyName; 
      entitycontactParams.partyRoleName = entity.PartyRoleLookup.LongName; 
      entitycontactParams.roleId = entity.PartyRoleLookup.SeqNo; 

      this.sharedService.setData('entitycontactParams', JSON.stringify({'projectId': this.projectId, 'entityId': entity.MIHProjectDevTeamID, 'contactId': contact.CommContactID, 'projectDevTeamContactId': contact.MIHProjectDevTeamContactID, 'entitycontactParams': entitycontactParams }));
      
      if (contact == null)
          this.router.navigate(['/entity/editcontact']);
      else {
          this.router.navigate(['/entity/editcontact']);

      }
  }

  getFormattedAddressLine(entity) {
      var ret = '';
      if (entity == null)
          return ret;

      if (entity.PartyAddress1 != null)
          ret += entity.PartyAddress1;

      if (entity.PartyAddress2 != null && entity.PartyAddress2 != '')
          ret += ', ' + entity.PartyAddress2;

      return ret;
  }
    

  //confirmContactDelete() {
     // this.showContactDelete = false;
 // }

}
